/* Animated tab title (sneako.com style): while the tab is in the background, the
   brand name fills in left-to-right one letter at a time, then restarts from the
   beginning and fills again — always forward, never deleting. When the tab is
   active again, the real page title is restored. */
(function () {
  var name = 'MUSLIM LANTERN';
  var original = document.title;
  var timer = null;
  var i = 1;
  var hold = 0; // brief pause on the full name before restarting

  function tick() {
    if (i >= name.length) {
      // Full name shown — hold a few ticks, then restart from the first letter.
      if (hold++ < 4) { return; }
      hold = 0; i = 1;
    } else {
      i++;
    }
    document.title = name.substring(0, i);
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      original = document.title;
      i = 1; hold = 0;
      document.title = name.charAt(0);
      timer = setInterval(tick, 240);
    } else {
      if (timer) { clearInterval(timer); timer = null; }
      document.title = original;
    }
  });
})();
